var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_vm._v(" Bắt đầu "),_c('hr'),_c('a-button',{attrs:{"type":"primary"}},[_vm._v("Primary")]),_c('a-button',[_vm._v("Default")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }